import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    PrimanotaExportVorschauData,
    PrimanotaExportVorschauVariante,
} from './nebenkosten-primanota-vorschau-dialog.models';

@Component({
    selector: 'kiene-nebenkosten-primanota-vorschau-dialog',
    templateUrl: './nebenkosten-primanota-vorschau-dialog.component.html',
    styleUrls: ['./nebenkosten-primanota-vorschau-dialog.component.scss'],
})
export class NebenkostenPrimanotaVorschauDialogComponent {
    /** 'neu' = kompakt_bu / Journal; 'alt' = legacy Lieferanten-Primanota. */
    modus: 'neu' | 'alt' = 'neu';

    constructor(
        public dialogRef: MatDialogRef<NebenkostenPrimanotaVorschauDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PrimanotaExportVorschauData,
    ) {}

    get aktiv(): PrimanotaExportVorschauVariante {
        return this.modus === 'alt' ? this.data.alt : this.data.neu;
    }

    setModus(m: 'neu' | 'alt'): void {
        this.modus = m;
    }

    close(): void {
        this.dialogRef.close();
    }

    formatEuro(n: number): string {
        return Number(n || 0).toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }
}
